import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** Usage: provide an index and project timeline content beside its marker. */
@Component({
  selector: 'app-timeline-item',
  templateUrl: './app-timeline-item.component.html',
  styleUrls: ['./app-timeline-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTimelineItemComponent {
  @Input() ariaLabel = '';
}